import { useHistory } from "react-router";

const MenuCard = ({ children, bg, to, style }) => {
    const history = useHistory()

    return (
        <div style={{
            ...styles.container,
            backgroundImage: `url(${bg})`,
            ...style
        }}
            onClick={() => to && history.push(to)}
        >
            <div style={styles.inner}>
                {children}
            </div>
        </div>
    )
}

const styles = {
    container: {
        display: 'flex',
        width: '19.3rem',
        height: '8.95rem',
        margin: '7% auto',
        backgroundPosition: 'center',
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat'
    },
    inner: {
        display: 'flex',
        borderRadius: '2.5rem',
        flex: 1,
        height: '100%',
        width: '100%',
        alignItems: 'center',
        justifyContent: 'left',
        paddingInline: '5%',
        boxShadow: '-.3rem -.3rem 1.2rem rgba(0, 0, 0, 0.25)',
        background: 'linear-gradient(90deg, rgb(0, 58, 92) 0%, rgb(0, 66, 105) 40%, rgba(0, 0, 0, 0) 100%)'
    }
}


export default MenuCard;